export const GET_ADMIN_GRIEVANCES_SUCCESS = "GET_ADMIN_GRIEVANCES_SUCCESS";
export const GET_ADMIN_GRIEVANCES_FAILURE = "GET_ADMIN_GRIEVANCES_FAILURE";

export const GET_SINGLE_ADMIN_GRIEVANCE_SUCCESS =
  "GET_SINGLE_ADMIN_GRIEVANCE_SUCCESS";
export const GET_SINGLE_ADMIN_GRIEVANCE_FAILURE =
  "GET_SINGLE_ADMIN_GRIEVANCE_FAILURE";

export const UPDATE_ADMIN_GRIEVANCE_SUCCESS = "UPDATE_ADMIN_GRIEVANCE_SUCCESS";
export const UPDATE_ADMIN_GRIEVANCE_FAILURE = "UPDATE_ADMIN_GRIEVANCE_FAILURE";
